/**
 * Normalizes US phone numbers from various formats to 10-digit format
 * Removes +1 country code prefix and any non-digit characters
 * Works with masked and unmasked input
 *
 * Examples:
 * - "+12345678901" -> "2345678901"
 * - "+1 (234) 567-8901" -> "2345678901"
 * - "1-234-567-8901" -> "2345678901"
 * - "(234) 567-8901" -> "2345678901"
 * - "234-567-8901" -> "2345678901"
 */
export function normalizeUSPhoneNumber(value: string): string {
  if (!value) return '';

  // Remove all non-digit characters (includes mask characters)
  let digitsOnly = value.replace(/\D/g, '');

  // If the number starts with '1' and has 11 digits total, remove the '1'
  if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
    digitsOnly = digitsOnly.substring(1);
  }

  // Return only the first 10 digits (in case there are extra digits)
  return digitsOnly.substring(0, 10);
}

